module.exports = __webpack_public_path__ + "img/cart-flatbed-empty.f6ae10fc.svg";